module.exports = __webpack_public_path__ + "img/brand_03.1208e3a6.png";